(() => {
  if (customElements.get('nny-box-builder')) return;
  const SIZE = 4;
  const make = (tag, cls, text) => { const el = document.createElement(tag); if (cls) el.className = cls; if (text !== undefined) el.textContent = text; return el; };
  const shuffle = input => { const out = [...input]; for (let i = out.length - 1; i > 0; i--) { const j = Math.floor(Math.random() * (i + 1)); [out[i], out[j]] = [out[j], out[i]]; } return out; };
  const safeImage = value => { try { const url = new URL(value, location.origin); return value && /^https?:$/.test(url.protocol) ? url.href : null; } catch { return null; } };

  customElements.define('nny-box-builder', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      this.dialog = this.querySelector('dialog');
      this.products = new Map(); this.order = []; this.selected = []; this.variants = new Map(); this.visible = 12;
      this.pending = false; this.transaction = null; this.loadedAt = 0;
      const signal = this.controller.signal;
      this.addEventListener('click', event => this.onClick(event), {signal});
      this.addEventListener('change', event => {
        const id = event.target.dataset.boxVariant;
        if (id) { this.variants.set(id, event.target.value); this.updateCard(id); }
      }, {signal});
      this.dialog.addEventListener('cancel', event => { if (this.pending) event.preventDefault(); }, {signal});
      this.dialog.addEventListener('click', event => { if (event.target === this.dialog && !this.pending) { const r = this.dialog.getBoundingClientRect(); if (event.clientX < r.left || event.clientX > r.right || event.clientY < r.top || event.clientY > r.bottom) this.dialog.close(); } }, {signal});
      this.dialog.addEventListener('close', () => {
        this.releaseScroll();
        this.loadController?.abort();
        if (!this.skipReturnFocus && this.returnFocus?.isConnected) this.returnFocus.focus({preventScroll:true});
        this.skipReturnFocus = false;
      }, {signal});
      this.renderSummary();
      if (location.hash === '#nnyTriggerBoxBuilder') this.open();
    }
    disconnectedCallback() {
      this.controller?.abort(); this.loadController?.abort(); this.controller = null;
      if (this.dialog?.open) { this.dialog.close(); this.releaseScroll(); }
    }
    q(selector) { return this.querySelector(selector); }
    money(cents) { return new Intl.NumberFormat(document.documentElement.lang || 'en-US', {style:'currency',currency:this.dataset.currency || 'USD'}).format(Number(cents || 0) / 100); }
    status(text) { const el = this.q('[data-box-status]'); el.textContent = text; el.hidden = !text; }
    releaseScroll() { if (this.ownsScrollLock) { document.body.style.overflow = this.previousOverflow || ''; this.ownsScrollLock = false; } }
    open(trigger) {
      if (this.dialog.open) return;
      this.returnFocus = trigger instanceof HTMLElement ? trigger : document.activeElement;
      this.previousOverflow = document.body.style.overflow;
      this.ownsScrollLock = true;
      document.body.style.overflow = 'hidden'; this.dialog.showModal();
      if (!this.loadedAt || Date.now() - this.loadedAt > 60000) this.load();
    }
    async request(url, options = {}) {
      const response = await fetch(url, {credentials:'same-origin',signal:AbortSignal.timeout(20000),...options});
      const data = await response.json();
      if (!response.ok) throw new Error(data.description || data.message || 'Your bag could not be updated. Please try again.');
      return data;
    }
    cartURL(suffix = '.js') { return this.dataset.cartUrl.replace(/\/$/, '') + suffix; }
    async page(number, signal) {
      const url = new URL(this.dataset.catalogUrl, location.origin);
      url.searchParams.set('section_id', 'nny-box-catalog'); url.searchParams.set('page', number);
      const preview = new URL(location.href).searchParams.get('preview_theme_id');
      if (preview) url.searchParams.set('preview_theme_id', preview);
      const response = await fetch(url, {credentials:'same-origin',signal,cache:'no-store'});
      if (!response.ok) throw new Error('Catalog unavailable');
      const node = new DOMParser().parseFromString(await response.text(), 'text/html').querySelector('[data-nny-box-catalog]');
      const data = JSON.parse(node?.textContent || 'null');
      if (!Array.isArray(data?.products) || Number(data.page) !== number) throw new Error('Catalog unavailable');
      return data;
    }
    async load() {
      if (this.loading) return;
      this.loading = true; this.loadController = new AbortController();
      const signal = AbortSignal.any([this.loadController.signal, AbortSignal.timeout(60000)]);
      const label = this.q('[data-box-load-status]'); label.hidden = false; label.textContent = 'Finding your next daily rotation…';
      this.q('[data-box-retry]').hidden = true;
      try {
        const first = await this.page(1, signal);
        this.dataset.currency = first.currency || this.dataset.currency;
        const pages = shuffle(Array.from({length:Math.max(1,Math.min(500,Number(first.pages) || 1))}, (_,i) => i + 1));
        const seen = new Set();
        for (const page of pages) {
          const data = page === 1 ? first : await this.page(page, signal);
          const fresh = [];
          for (const item of data.products) {
            if (!item.id || item.giftCard || item.requiresPlan) continue;
            item.variants = (item.variants || []).filter(v => v.available && Number(v.min || 1) === 1 && Number(v.step || 1) === 1 && (v.max == null || Number(v.max) >= 1) && Number.isFinite(Number(v.price)));
            if (!item.variants.length) continue;
            item.id = String(item.id); item.variants.forEach(v => { v.id = String(v.id); v.price = Number(v.price); });
            seen.add(item.id);
            if (!this.products.has(item.id)) fresh.push(item.id);
            this.products.set(item.id, item);
            if (!item.variants.some(v => v.id === this.variants.get(item.id))) this.variants.set(item.id, item.variants[0].id);
          }
          this.order.push(...shuffle(fresh)); this.renderProducts();
          label.textContent = 'Loading more formulas…';
        }
        for (const id of this.products.keys()) if (!seen.has(id)) this.products.delete(id);
        this.order = this.order.filter(id => seen.has(id));
        if (!this.transaction) {
          const previous = this.selected.length;
          this.selected = this.selected.flatMap(entry => {
            const p = this.products.get(entry.product.id), v = p?.variants.find(v => v.id === entry.variant.id);
            return p && v ? [{product:p,variant:v}] : [];
          });
          if (previous !== this.selected.length) this.status('The lineup has changed. Please replace the unavailable selections.');
        }
        this.loadedAt = Date.now(); this.renderProducts(); this.renderSummary();
        label.textContent = this.order.length ? '' : 'The next Borough edit is on its way. Check back soon for available formulas.';
        label.hidden = !!this.order.length;
      } catch (error) {
        if (this.loadController.signal.aborted) return;
        label.textContent = this.products.size ? 'Some formulas could not load. You can keep building or try again.' : 'The lineup could not load. Please try again.';
        this.q('[data-box-retry]').hidden = false;
      } finally { this.loading = false; if (this.loadController.signal.aborted && this.dialog.open && this.isConnected) this.load(); }
    }
    image(src, alt, cls) {
      const safe = safeImage(src);
      if (!safe) return make('span', cls || 'nb-placeholder', 'N.N.Y');
      const img = make('img', cls); img.src = safe; img.alt = alt; img.width = 240; img.height = 240; img.loading = 'lazy'; img.decoding = 'async'; return img;
    }
    renderProducts() {
      const focus = document.activeElement;
      const focusedID = focus?.closest('[data-box-product]')?.dataset.boxProduct;
      const focusedSelect = !!focus?.matches('[data-box-variant]');
      const grid = this.q('[data-box-products]'); grid.replaceChildren();
      for (const id of this.order.slice(0,this.visible)) {
        const p = this.products.get(id); if (!p) continue;
        const card = make('article', 'nb-product'); card.dataset.boxProduct = id;
        const photo = make('div','nb-photo'); photo.dataset.boxPhoto = '';
        const body = make('div','nb-product-body'); body.append(make('h3','nb-product-name',p.title));
        const price = make('span','nb-price'); price.dataset.boxPrice = ''; body.append(price);
        if (!p.defaultVariant || p.variants.length > 1) {
          const label = make('label','nb-variant','Choose your formula'); const select = make('select'); select.dataset.boxVariant = id; select.setAttribute('aria-label','Choose an option for '+p.title);
          for (const v of p.variants) { const option = make('option','',v.title); option.value = v.id; select.append(option); }
          select.value = this.variants.get(id); label.append(select); body.append(label);
        }
        const add = make('button','nb-add','Add to box'); add.type = 'button'; add.dataset.boxAdd = id; body.append(add);
        card.append(photo,body); grid.append(card); this.updateCard(id);
      }
      this.q('[data-box-count]').textContent = `${this.products.size} available ${this.products.size === 1 ? 'formula' : 'formulas'}`;
      this.q('[data-box-more]').hidden = this.visible >= this.order.length;
      this.q('[data-box-shuffle]').disabled = this.order.length < 2 || this.pending || !!this.transaction;
      if (focusedID) this.q(`[data-box-product="${CSS.escape(focusedID)}"] ${focusedSelect ? 'select' : '[data-box-add]'}`)?.focus({preventScroll:true});
    }
    updateCard(id) {
      const p = this.products.get(id), card = this.q(`[data-box-product="${CSS.escape(id)}"]`);
      if (!p || !card) return;
      const v = p.variants.find(v => v.id === this.variants.get(id)) || p.variants[0];
      const chosen = this.selected.filter(x => x.variant.id === v.id).length;
      card.classList.toggle('is-selected',this.selected.some(x => x.product.id === id));
      card.querySelector('[data-box-price]').textContent = this.money(v.price);
      const photo = card.querySelector('[data-box-photo]');
      if (photo.dataset.variant !== v.id) { photo.replaceChildren(this.image(v.image || p.image,p.title)); photo.dataset.variant = v.id; }
      const add = card.querySelector('[data-box-add]');
      add.textContent = chosen ? `Add another · ${chosen} in box` : 'Add to box';
      add.disabled = this.pending || !!this.transaction || this.selected.length >= SIZE || (v.max != null && chosen >= Number(v.max));
      const select = card.querySelector('select'); if (select) select.disabled = this.pending || !!this.transaction;
    }
    renderSummary() {
      const slots = this.q('[data-box-slots]'); slots.replaceChildren();
      for (let i=0;i<SIZE;i++) {
        const entry = this.selected[i], slot = make('li',entry ? 'nb-slot' : 'nb-slot nb-slot-empty');
        if (entry) {
          slot.append(this.image(entry.variant.image || entry.product.image,''));
          const copy = make('div','nb-slot-copy'); copy.append(make('strong','',entry.product.title));
          if (!entry.product.defaultVariant) copy.append(make('small','',entry.variant.title));
          copy.append(make('span','',this.money(entry.variant.price)));
          const remove = make('button','nb-remove','×'); remove.type = 'button'; remove.dataset.boxRemove = i; remove.setAttribute('aria-label','Remove '+entry.product.title+' from box'); remove.disabled = this.pending || !!this.transaction;
          slot.append(copy,remove);
        } else slot.append(make('span','nb-slot-index',String(i+1).padStart(2,'0')),make('span','','Your next pick.'));
        slots.append(slot);
      }
      const subtotal = this.selected.reduce((sum,x) => sum + x.variant.price,0), savings = Math.round(subtotal * .05);
      this.q('[data-box-progress]').textContent = `${this.selected.length} / ${SIZE}`;
      this.q('[data-box-meter]').style.width = `${this.selected.length / SIZE * 100}%`;
      this.q('.nb-meter').setAttribute('aria-valuenow',this.selected.length);
      this.q('[data-box-subtotal]').textContent = this.money(subtotal);
      this.q('[data-box-savings]').textContent = '−'+this.money(savings);
      this.q('[data-box-total]').textContent = this.money(subtotal-savings);
      const submit = this.q('[data-box-submit]');
      submit.disabled = this.pending || this.selected.length !== SIZE;
      submit.textContent = this.pending ? 'UPDATING YOUR BAG…' : this.transaction?.added ? 'RETRY 5% CODE' : this.transaction ? 'RETRY ADDING BOX' : this.selected.length === SIZE ? 'ADD BOX TO BAG · SAVE 5%' : `CHOOSE ${SIZE-this.selected.length} MORE ${SIZE-this.selected.length === 1 ? 'FORMULA' : 'FORMULAS'}`;
      this.q('[data-box-close]').disabled = this.pending;
      this.q('[data-box-bag]').hidden = !this.transaction;
      this.q('[data-box-bag]').disabled = this.pending;
      const edit = this.q('[data-box-edit]'); if (edit) { edit.hidden = !this.transaction; edit.disabled = this.pending; }
      for (const id of this.order.slice(0,this.visible)) this.updateCard(id);
      this.q('[data-box-shuffle]').disabled = this.order.length < 2 || this.pending || !!this.transaction;
    }
    onClick(event) {
      const button = event.target.closest('button'); if (!button || button.disabled) return;
      if (button.hasAttribute('data-box-close')) this.dialog.close();
      else if (button.hasAttribute('data-box-retry')) this.load();
      else if (button.hasAttribute('data-box-shuffle')) { this.order = shuffle(this.order); this.visible = 12; this.renderProducts(); }
      else if (button.hasAttribute('data-box-more')) { this.visible += 12; this.renderProducts(); }
      else if (button.hasAttribute('data-box-add') && !this.pending && !this.transaction && this.selected.length < SIZE) {
        const p = this.products.get(button.dataset.boxAdd), v = p?.variants.find(v => v.id === this.variants.get(p.id));
        if (!v) return;
        this.selected.push({product:p,variant:v}); this.status(''); this.renderSummary();
      } else if (button.hasAttribute('data-box-remove') && !this.pending && !this.transaction) {
        this.selected.splice(Number(button.dataset.boxRemove),1); this.status(''); this.renderSummary();
        this.q('[data-box-remove]')?.focus({preventScroll:true});
      } else if (button.hasAttribute('data-box-submit')) this.submit();
      else if (button.hasAttribute('data-box-bag')) this.openBag();
      else if (button.hasAttribute('data-box-edit')) this.editSelection();
    }
    transactionCounts(cart) {
      const counts = new Map();
      for (const line of cart.items || []) if (line.properties?._nny_box_id === this.transaction.id) counts.set(String(line.variant_id), (counts.get(String(line.variant_id)) || 0) + line.quantity);
      return counts;
    }
    existingCodes(cart) {
      const codes = (cart.discount_codes || []).map(d => d.code);
      const applications = [...(cart.cart_level_discount_applications || []), ...(cart.items || []).flatMap(i => (i.line_level_discount_allocations || []).map(d => d.discount_application))];
      for (const app of applications) if (app?.type === 'discount_code' && app.title) codes.push(app.title);
      return [...new Set(codes.filter(Boolean))];
    }
    discountApplied(cart, code) {
      const same = value => String(value || '').toUpperCase() === code.toUpperCase();
      if ((cart.discount_codes || []).some(d => same(d.code) && d.applicable === true)) return true;
      const apps = [...(cart.cart_level_discount_applications || []), ...(cart.items || []).flatMap(i => (i.line_level_discount_allocations || []).map(d => d.discount_application))];
      return apps.some(d => same(d?.title) && Number(d.total_allocated_amount || 0) > 0);
    }
    async submit() {
      if (this.pending || this.selected.length !== SIZE) return;
      this.pending = true; this.status('Adding your Borough edit and checking your 5% code…'); this.renderSummary();
      try {
        let cart = await this.request(this.cartURL());
        if (cart.currency && cart.currency !== this.dataset.currency) throw new Error('Your currency has changed. Refresh the page before adding this box.');
        if (!this.transaction) {
          const amounts = new Map(); for (const x of this.selected) amounts.set(x.variant.id,(amounts.get(x.variant.id) || 0)+1);
          this.transaction = {id:crypto.randomUUID(),items:[...amounts].map(([id,quantity]) => ({id,quantity})),added:false};
        }
        const counts = this.transactionCounts(cart);
        const missing = this.transaction.items.map(item => ({...item,quantity:Math.max(0,item.quantity-(counts.get(item.id)||0)),properties:{'Borough Box':'4-piece edit',_nny_box_id:this.transaction.id}})).filter(item => item.quantity > 0);
        if (missing.length) {
          try { await this.request(this.cartURL('/add.js'),{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({items:missing})}); }
          catch (error) {
            // A lost response or partial stock failure may still have added items. Reconcile before any retry.
            const reconciled = await this.request(this.cartURL());
            const current = this.transactionCounts(reconciled);
            if (!this.transaction.items.every(x => (current.get(x.id)||0) >= x.quantity)) throw error;
          }
          cart = await this.request(this.cartURL());
        }
        // A transport retry can replay an add request. Trim only this transaction's excess units.
        const remaining = new Map(this.transaction.items.map(x => [x.id,x.quantity]));
        for (const line of cart.items.filter(x => x.properties?._nny_box_id === this.transaction.id)) {
          const id = String(line.variant_id), keep = Math.min(line.quantity,remaining.get(id) || 0);
          remaining.set(id,Math.max(0,(remaining.get(id)||0)-keep));
          if (keep < line.quantity) cart = await this.request(this.cartURL('/change.js'),{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({id:line.key,quantity:keep})});
        }
        const current = this.transactionCounts(cart);
        if (!this.transaction.items.every(x => (current.get(x.id)||0) === x.quantity)) throw new Error('Some formulas could not be added. Retry, or remove these box items and edit your selection.');
        this.transaction.added = true;
        const code = (this.dataset.discountCode || 'NNYBOX5').trim();
        const codes = this.existingCodes(cart).filter(x => x.toUpperCase() !== code.toUpperCase()); codes.push(code);
        cart = await this.request(this.cartURL('/update.js'),{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({discount:codes.join(',')})});
        document.dispatchEvent(new CustomEvent('nny:cart-updated',{detail:{source:'box',cart}}));
        if (!this.discountApplied(cart,code)) throw new Error('Your box is in your bag, but the 5% code could not be applied. Review your bag or retry the code. Your items will not be added twice.');
        this.selected = []; this.transaction = null; this.status(''); this.pending = false; this.renderSummary(); this.openBag();
      } catch (error) {
        this.status(error.message || 'Your box could not be added. Please try again.');
        this.q('[data-box-status]').focus({preventScroll:true});
      } finally { this.pending = false; this.renderSummary(); }
    }
    async editSelection() {
      if (this.pending || !this.transaction) return;
      this.pending = true; this.status('Removing this box from your bag so you can edit it…'); this.renderSummary();
      try {
        let cart = await this.request(this.cartURL());
        for (const item of cart.items.filter(x => x.properties?._nny_box_id === this.transaction.id)) cart = await this.request(this.cartURL('/change.js'),{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({id:item.key,quantity:0})});
        this.transaction = null; this.status('You can edit your selection now.');
        document.dispatchEvent(new CustomEvent('nny:cart-updated',{detail:{source:'box',cart}}));
      } catch (error) { this.status(error.message); }
      finally { this.pending = false; this.renderSummary(); }
    }
    openBag() {
      const trigger = this.returnFocus; this.skipReturnFocus = true; this.releaseScroll(); this.dialog.close();
      if (typeof window.nnyOpenCartDrawer === 'function') window.nnyOpenCartDrawer(trigger);
      else location.assign(this.dataset.cartUrl);
    }
  });
  window.nnyOpenBoxBuilder = trigger => document.querySelector('nny-box-builder')?.open(trigger);
  document.addEventListener('click', event => {
    const trigger = event.target.closest('a,button'); if (!trigger || event.defaultPrevented || event.button > 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    let matches = trigger.matches('#nnyTriggerBoxBuilder,[data-open-box-builder],[data-full-box]');
    if (!matches && trigger.href) { try { const url = new URL(trigger.href); matches = url.origin === location.origin && url.hash === '#nnyTriggerBoxBuilder'; } catch {} }
    if (!matches || !document.querySelector('nny-box-builder')) return;
    event.preventDefault();
    const menu = trigger.closest('details'); if (menu) menu.open = false;
    window.nnyOpenBoxBuilder(menu?.querySelector('summary') || trigger);
  });
  window.addEventListener('hashchange', () => { if (location.hash === '#nnyTriggerBoxBuilder') window.nnyOpenBoxBuilder(); });
})();
